/**
 * Service: systemApi
 */
angular.module('acme.common.service.systemApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder'
])
.service('SystemApiService', [ '$http', 'ApiVersionFactory', 'QueryStringBuilderFactory', function($http, ApiVersionFactory, QueryStringBuilderFactory) {

    return {

      service: '',

      init: function(endpoint) {
        this.service = endpoint;
        return this;
      },

      csrf: function() {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/csrf', version: 'v2' })
        });
      },

      preFlightCheck: function(props) {

        var q = '',
            av = new ApiVersionFactory();

        if (props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              requires: ['hostName']
            }
          });

          q = qs.query;
        }

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/auth/resolve' + q, version: 'v2' })
        });
      },

      uuidObjectRegistry: function(props) {
        var av = new ApiVersionFactory();

        return $http({
          method: 'get',
          url: av.init({ url: this.service + '/uuidobjectregistry/' + props.uuid, version: 'v2' })
        });

      },

      complete: {
        service: '',

        list: function(props) {

          var q = '',
              av = new ApiVersionFactory();

          if (props) {
            var qs = new QueryStringBuilderFactory({
              props: props,
              fields: {
                optional: ['pageSize', 'page', 'sortField', 'sortDirection', 'search']
              }
            });
            q = qs.query;
          }

          return $http({
            method: 'get',
            url: av.init({ url: this.service + q, version: 'v2' })
          });

        },

        create: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              // TODO: Populate
            }
          });

        },

        update: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({ url: this.service, version: 'v2' }),
            data: {
              id: props.id
            }
          });

        },

        remove: function(props) {

          var av = new ApiVersionFactory();

          return $http({
            method: 'delete',
            url: av.init({ url: this.service + '/' + props.id, version: 'v2' })
          });

        }

      }

    };

}]);